import React from 'react';
import { useSubscription } from '../../hooks/useSubscription';

const PLAN_COLORS = {
  free: 'bg-white/10 text-muted-foreground border-white/10',
  basic: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
  pro: 'bg-primary/10 text-primary border-primary/20',
  elite: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
};

const PLAN_LABELS = {
  free: 'Free',
  basic: 'Basic',
  pro: 'Pro',
  elite: 'Elite',
};

/**
 * Small badge showing the user's current plan.
 */
export default function PlanBadge({ className = '' }) {
  const { planId } = useSubscription();

  const colorClass = PLAN_COLORS[planId] || PLAN_COLORS.free;
  const label = PLAN_LABELS[planId] || planId;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full border ${colorClass} ${className}`}>
      {label}
    </span>
  );
}
